/**
 * Copyright © Veeam Software Group GmbH.
 */

export const getStartOfTheDay = (day: Date): Date => new Date(new Date(day).setHours(0, 0, 0, 0));
